import { useEffect, useMemo, useState } from "react";
import type {
  NotificationCategory,
  NotificationFilters,
  NotificationSeverity,
  NotificationStatusFilter,
} from "@/lib/notification.api";
import { ALL_FILTER_VALUE, PAGE_SIZE, type AllFilterValue } from "../notification.constants";

export type CategoryFilterValue = NotificationCategory | AllFilterValue;
export type SeverityFilterValue = NotificationSeverity | AllFilterValue;

export function useNotificationInboxState() {
  const [status, setStatus] = useState<NotificationStatusFilter>("unread");
  const [category, setCategory] = useState<CategoryFilterValue>(ALL_FILTER_VALUE);
  const [severity, setSeverity] = useState<SeverityFilterValue>(ALL_FILTER_VALUE);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => setPage(1), [status, category, severity, search]);

  const filters = useMemo<NotificationFilters>(
    () => ({
      status,
      category: category === ALL_FILTER_VALUE ? undefined : category,
      severity: severity === ALL_FILTER_VALUE ? undefined : severity,
      search: search.trim() || undefined,
      page,
      pageSize: PAGE_SIZE,
    }),
    [category, page, search, severity, status],
  );

  return {
    status,
    setStatus,
    category,
    setCategory,
    severity,
    setSeverity,
    search,
    setSearch,
    page,
    setPage,
    filters,
  };
}
